// extracted by mini-css-extract-plugin
export default {"card":"statsCard_card__2pOf8","text":"statsCard_text__O1Otn"};